/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    EMAIL_TASK: 'email-task',
    BILLING_TASK: 'billing-task',
};
